export const logoNegative = ['608 134', `
<img src="../../public/novo-logo-skenn.png" />
`]
